import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeToggleComponent } from './theme-toggle.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [ThemeToggleComponent],
  imports: [CommonModule, SvgIconModule],
  exports: [ThemeToggleComponent],
})
export class ThemeToggleModule {}
